export const  SALARY_TYPE = {
  RANGE: 'RANGE',
  FIX: 'FIX'
}

export const TIME_TYPE = {
  WEEK: 'WEEK',
  MONTH: 'MONTH'
}

export const WORK_TIME_TYPE = {
  PART_TIME: 'PARTTIME',
  FULL_TIME: 'FULLTIME'
}

export const RECRUITE_STATUS = {
  TUYENGAP: "Tuyển Gấp",
  BINHTHUONG: "Bình Thường"
}

export const FINANCE_HELPER = [
  {
    label: 'Chấp Nhận',
    value: 'ACCEPT'
  },
  {
    label: 'Từ Chối',
    value: 'IGNORE'
  },
  {
    label: 'Đang sắp xếp lịch',
    value: 'AWAITTING'
  }
]
export const FINANCE_HELPER_VALUE = {
ACCEPT: 'Chấp Nhận',
IGNORE: 'Từ Chối',
AWAITTING: 'Đang sắp xếp lịch'
}